import { connect } from "react-redux";
import PrivateRoute from "./PrivateRoute";

function mapStateToProps(state) {
    return {
        isAuthenticated: !!(localStorage.getItem("token")),
        isLoginPending: !!state.authReducer.isLoginPending,
        authReduc: state.authReducer
    };
}

const connectedPrivateRoute = connect(mapStateToProps, null)(PrivateRoute);

export default connectedPrivateRoute;
